export var INVALID_CREDENTIALS = "Invalid credentials";